import axios from 'axios';

const token = localStorage.getItem('token'); 
export default axios.create({
  baseURL: 'https://localbells.com/localbells/api/v1/',
  timeout: 500000,
  headers: {
      "Content-Type": "multipart/form-data",
      'Authorization': `Bearer ${token}`
  }
});